/**
 * Language resource for text related to the login and password reset functionality.
 * @typedef {Object} LoginPasswordTextResources
 * @property {string} loginTitle - Title for the login page.
 * @property {string} email - Label for email field.
 * @property {string} emailPlaceholder - Placeholder for email field.
 * @property {string} password - Label for password field.
 * @property {string} passwordPlaceholder - Placeholder for password field.
 * @property {string} rememberMe - Label for remember me checkbox.
 * @property {string} forgotPasswordLink - Text for the forgot password link.
 * @property {string} adminWelcome - Welcome message for admin.
 * @property {string} adminLoginDescription - Description for admin login.
 * @property {string} submit - Text for the sign in button.
 * @property {string} signin - Text for the sign-in action.
 * @property {string} send - Text for the send action (e.g., sending reset password instructions).
 * @property {string} forgotPasswordTitle - Title for the forgot password page.
 * @property {string} backToSignIn - Text for the back to sign in link.
 * @property {string} title - Title for the reset password page.
 * @property {string} resetDescription - Description for resetting password.
 * @property {string} newPassword - Label for new password field.
 * @property {string} newPasswordPlaceholder - Placeholder for new password field.
 * @property {string} confirmPasswordPlaceholder - Placeholder for confirming new password field.
 * @property {string} confirmPassword - Label for confirming new password field.
 * @property {string} passwordContains - Label indicating password criteria.
 * @property {string} reset - Text for the reset password action.
 * @property {string} passwordContain - Label indicating password criteria.
 * @property {string} letter - Password criteria: at least 1 capital letter.
 * @property {string} number - Password criteria: at least 1 special character & 1 number.
 * @property {string} long - Password criteria: 6-12 characters long.
 * @property {string} description - Description for setting a unique password.
 * @property {string} oldPassword - Label for old password field.
 * @property {string} currentPlaceholder - Placeholder for current password field.
 * @property {string} newPlaceholder - Placeholder for new password field.
 * @property {string} capitalLetter - Password criteria: at least 1 capital letter & 1 small letter.
 * @property {string} specialCharacterNumber - Password criteria: at least 1 special character & 1 number.
 * @property {string} characterLength - Password criteria: 6-15 characters long.
 * @property {string} updatePassword - Text for updating password action.
 * @property {string} confirmNewPassword - Label for confirming new password field during password update.
 * @property {string} changePassword - Text for changing password action.
 * @property {string} verifyCodeMessage - Message prompting user to enter verification code.
 * @property {string} resendCode - Text for resending verification code action.
 * @property {string} signInPageParagraph - Paragraph on the sign-in page.
 */

/**
 * Language resource for text related to the login and password reset functionality.
 * @type {LoginPasswordTextResources}
 */

export const text = {
  loginTitle: "Login",
  email: "Email",
  emailPlaceholder: "Enter your email address",
  password: "Password",
  passwordPlaceholder: "Enter your password",
  rememberMe: "Remember Me",
  forgotPasswordLink: "Forgot Password?",
  adminWelcome: "Welcome,",
  adminLoginDescription:
    "Access the Daakia panel using your email and password.",
  submit: "Sign In",
  signin: "Sign-In",
  send: "Send",
  forgotPasswordTitle:
    "If you forgot your password, well, then we’ll email you instructions to reset your password.",
  backToSignIn: "Back to Sign In",
  title: "Reset Password",
  resetDescription: "Create your new password.",
  newPassword: "New Password",
  newPasswordPlaceholder: "Enter new password",
  confirmPasswordPlaceholder: "Confirm new password",
  confirmPassword: "Confirm New Password",
  passwordContains: "Password contains",
  reset: "Reset",
  passwordContain: "Password contains:",
  letter: "At least 1 Capital  Letter.",
  number: "At least 1 Special  Character & 1 Number.",
  long: "6-12 characters long.",
  description: "Set a unique password to protect your account.",
  oldPassword: "Old Password",
  currentPlaceholder: "Enter current password",
  newPlaceholder: "Enter New Password",
  confirmPlaceholder: "Confirm New Password",
  capitalLetter: "At least 1 Capital Letter & 1 Small Letter",
  specialCharacterNumber: "At least 1 Special Character & 1 Number.",
  characterLength: "6-15 Character long.",
  updatePassword: "Update Password",
  // submit: "Update Password",
  confirmNewPassword: "Confirm New Password",
  changePassword: "Change Password",
  verifyCodeMessage:
    "Please enter the verification code received on your email..",
  resendCode: "Resend Code",
  signInPageParagraph: "Access the admin panel using your email and password.",
  name: 'Name',
  enterYourName: 'Enter your name',
  enterDescription: "Please enter a description",
  descriptionLabel: "Description",
};
